import { moneyFormatter } from "../../../../utils/moneyFormatter"

export const Ticket = (props) => {
  return (
    <div className="jackpotTicket" onClick={()=>{props?.setModalOpen(true)}}>
      <div>{moneyFormatter(props?.tickets ?? 0, "", false)}</div>
      <div>{props?.entries}</div>
    </div>
  )
}